import { createContext } from 'react';

/**
 * Context for all top-level application paths.
 */
export const AppPathsContext = createContext([]);
export const AppPathsProvider = AppPathsContext.Provider;
export const AppPathsConsumer = AppPathsContext.Consumer;
